<ng-template #template>
  <div (pointerdown)="question.onPointerDown($event, row)">
    <svg *ngIf="question.iconDragElement" [class]="question.cssClasses.dragElementDecorator">
      <use [attr.xlink:href]="question.iconDragElement"></use>
    </svg>
    <span *ngIf="!question.iconDragElement" data-bind="css: question.cssClasses.iconDrag"></span>
  </div>
</ng-template>